export default __webpack_public_path__ + "static/bmw_padsrotors-d76d4d5f40007f3b83f600875f40ef23.jpg";